import React from 'react'
import NumberFormat from 'react-number-format';
import { H } from '../utils.tsx';
import * as settings from '../settings.js'


export const AgeText = ({ 
  data
}: {
  data: Array<any>
}) => {

  // Calculate Sums
  const sumNotRepresented = data.agedistribution
    .filter(e => e.yeartorepresentative > 10 && e.age >= 18)
    .reduce((e, current) => {return {count: e.count + current.count}})

  const sumTotal = data.agedistribution
    .filter(e => e.age >= 18)
    .reduce((e, current) => {return {count: e.count + current.count}})

  return (
    <div className='ageText'>
      <h3>So setzt sich der {settings.executive[data.type].noun} in {data.name} zusammen</h3>
      <p>
        Angenommen, eine {settings.executive[data.type].w} repräsentiert jene Bewohner, die zehn Jahre jünger bis zehn Jahre{' '} 
        älter sind als sie selbst ist, so heisst dies für {data.name}:
        {' '}<H>
        <NumberFormat
          value={sumNotRepresented.count}
          thousandSeparator="'"
          displayType='text'
        />{' '}Menschen,{' '}
        {Math.round(100 / sumTotal.count * sumNotRepresented.count)} Prozent der Volljährigen, werden nicht vertreten.</H>
      </p>
      <p>
        Folgende Grafik zeigt, welche Altersgruppen in {data.name} repräsentiert werden. Wählen Sie eine{' '}
        {settings.executive[data.type].w} oder einen {settings.executive[data.type].m} aus.
      </p>


    </div>
  )
}
